import { ResponsivePie } from "@nivo/pie";
import { useTranslation } from "react-i18next";
import { byStateTheme, useNivoTheme } from "../../../../common/theme";
import { ApproveState } from "../../../../redux/api/VehiclesApi";
import { CountByState } from "../../../../common/pagination";
import { Box } from "@mui/material";

interface VehicleByStateChartDatum {
  id: string;
  label: string;
  value: number;
  state: ApproveState;
}

const VehiclesByState = (props: { data?: CountByState }) => {
  const { t } = useTranslation();
  const titleActive = t("reports.organization.vehicles.approval.active");
  const titleDeclined = t("reports.organization.vehicles.approval.declined");
  const titlePending = t("reports.organization.vehicles.approval.pending");
  const countActive = props.data?.active ?? 0;
  const countDeclined = props.data?.declined ?? 0;
  const countPending = props.data?.pending ?? 0;

  const chartData: VehicleByStateChartDatum[] = [
    {
      id: titleActive,
      label: `${titleActive} (${countActive})`,
      value: countActive,
      state: ApproveState.ACTIVE,
    },
    {
      id: titleDeclined,
      label: `${titleDeclined} (${countDeclined})`,
      value: countDeclined,
      state: ApproveState.DECLINED,
    },
    {
      id: titlePending,
      label: `${titlePending} (${countPending})`,
      value: countPending,
      state: ApproveState.PENDING,
    },
  ];

  return (
    <>
      <Box textAlign={"center"}>
        {t("reports.organization.vehicles.approval.title")}
      </Box>
      <ResponsivePie
        margin={{ top: 10, right: 0, bottom: 80, left: 0 }}
        data={chartData}
        animate={true}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        activeInnerRadiusOffset={6}
        layers={["arcs", "legends"]}
        colors={byStateTheme.palette.pie}
        theme={useNivoTheme()}
        legends={[
          {
            anchor: "bottom-left",
            direction: "column",
            symbolShape: "circle",
            itemWidth: 100,
            itemHeight: 20,
            translateY: 70,
            translateX: 30,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 0.5,
                },
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default VehiclesByState;
